import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import Section from "./Section";
import { useParams } from "react-router-dom";
import PageLoadingSpinner from "components/common/PageLoader";
import BreadCrumb from "components/common/BreadCrumb";
import { User } from "../types/user.types";
import UserOverviewContext from "./UserOverviewContext";
import { getDocumentTitle } from "utils/helpers";
import { getUser } from "../services/UserService";

const UserOverview = ({
  title: titleProp,
  pageTitle: pageTitleProp,
}: {
  title?: string;
  pageTitle?: string;
}) => {
  const title = titleProp ?? "User Details";
  const pageTitle = pageTitleProp ?? "User Management";
  document.title = getDocumentTitle(title);
  const { id: paramId } = useParams();
  const id = paramId;
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        if (id) {
          const response = await getUser(Number(id));
          if (response.success) {
            setUser(response.data);
          }
        }
      } catch (err) {
        console.warn(err);
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, [id]);

  if (loading) return <PageLoadingSpinner message="Loading user..." />;

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title={title}
          pageTitle={pageTitle}
          items={[{ label: "Users", path: "/user-management/users" }]}
        />
        <UserOverviewContext.Provider value={{ user }}>
          <Section />
        </UserOverviewContext.Provider>
      </Container>
    </div>
  );
};

export default UserOverview;
